var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.696 4.10163C15.7493 3.83663 15.626 3.56829 15.3918 3.43496C15.1568 3.30246 14.8626 3.33496 14.6626 3.51663C14.6626 3.51663 13.791 4.30913 12.8076 5.20329C12.3476 5.62163 11.7101 5.78413 11.106 5.63829C10.5018 5.49246 10.0093 5.05663 9.79097 4.47413L8.58514 1.25996C8.49347 1.01579 8.26097 0.854126 8.00014 0.854126C7.7393 0.854126 7.5068 1.01579 7.41514 1.25996L6.2093 4.47413C5.99097 5.05663 5.49847 5.49246 4.8943 5.63829C4.29014 5.78413 3.65264 5.62163 3.19264 5.20329C2.2093 4.30913 1.33764 3.51663 1.33764 3.51663C1.13764 3.33496 0.843471 3.30246 0.608471 3.43496C0.374304 3.56829 0.250971 3.83663 0.304304 4.10163C0.304304 4.10163 1.2318 8.73913 1.70264 11.095C1.9168 12.1666 2.85764 12.9375 3.95014 12.9375H12.0501C13.1426 12.9375 14.0835 12.1666 14.2976 11.095C14.7685 8.73913 15.696 4.10163 15.696 4.10163Z",
    fill: "#117573"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/Premium.d2da2506b66263bd32c65edc1acd4a60.svg";
export { ForwardRef as ReactComponent };